import { render, staticRenderFns } from "./AskForModification.vue?vue&type=template&id=59c84619"
import script from "./AskForModification.vue?vue&type=script&lang=js"
export * from "./AskForModification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports